var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"on-clickaway",rawName:"v-on-clickaway",value:(_vm.away),expression:"away"}],staticClass:"relative",on:{"click":_vm.toggle}},[_vm._t("toggler",[_c('button',[_vm._v("Toggle")])]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }